import { Box, Flex } from '@radix-ui/themes';
import { SectionHeader } from 'components/sections/header';
import { PitchListAvatarHeader } from 'components/sections/pitch-list/list/avatar-header';
import { PitchListToolbar } from 'components/sections/pitch-list/list/toolbar';
import { PitchCard } from 'components/sections/pitch-list/pitch-card';
import { PitchesHeader } from 'components/sections/pitches/header';
import { MlbSportId } from 'lib_ts/enums/mlb-stats-api/base.enum';
import { PitchListOwner, PLStoreMode } from 'lib_ts/enums/pitch-list.enums';
import { BuildPriority } from 'lib_ts/enums/pitches.enums';
import { DEFAULT_PITCH, IPitchList } from 'lib_ts/interfaces/pitches';

const DUMMY_PITCHES = Array.from({ length: 8 }).map(() => ({
  ...DEFAULT_PITCH,
  priority: BuildPriority.Breaks,
}));

const DUMMY_LIST: IPitchList = {
  _id: '',
  _parent_id: '',
  _parent_def: PitchListOwner.User,
  folder: '',
  name: 'Lorem Ipsum (2025)',
  super: false,
  team: 'Lorem Ipsum',
  pitcher: 'John Doe',
  mlb_repertoire: {
    season: 2025,
    sportId: MlbSportId.MLB,
    playerPk: 0,
  },
  _created: '',
  _changed: '',
};

interface IProps {
  mode: PLStoreMode;
}

export const PitchListSkeleton = ({ mode }: IProps) => {
  return (
    <>
      {mode === PLStoreMode.Library ? (
        <PitchesHeader />
      ) : (
        <SectionHeader
          headerNode={<PitchListAvatarHeader list={DUMMY_LIST} loading />}
          breadcrumbs={[
            {
              label: 'main.pitches',
            },
            {
              label: 'main.pitch-lists',
            },
            {
              label: DUMMY_LIST.name,
            },
          ]}
          loading
        />
      )}

      <PitchListToolbar loading />

      <Box
        flexGrow="1"
        style={{
          overflowX: 'hidden',
          overflowY: 'auto',
        }}
      >
        <Flex direction="column" gap="2">
          {DUMMY_PITCHES.map((p, i) => (
            <PitchCard
              key={i}
              pitch={p}
              targetActions={[]}
              onTrainFn={() => {}}
              loading
            />
          ))}
        </Flex>
      </Box>
    </>
  );
};
